export default {
  fields: {
    target: {
      type: 'selector',
      value: '',
      options: [
        {
          value: 'budget',
          min: 10000,
          max: 10000000,
        },
        {
          value: 'clicks',
          min: 300,
          max: 10000000,
        },
        {
          value: 'shows',
          min: 35000,
          max: 10000000,
        },
      ],
      sub_field: {
        name: 'desired_value',
        type: 'text',
        value: '',
      },
    },
    industry_id: {
      type: 'selector',
      options: [],
      value: '',
      dependencies: ['target', 'desired_value'],
      apiDependencies: [],
      apiMethod: 'fetchIndustries',
    },
    sub_industry_id: {
      type: 'selector',
      options: [],
      value: '',
      dependencies: ['target', 'desired_value', 'industry_id'],
      apiDependencies: ['industry_id'],
      apiMethod: 'fetchSubIndustries',
    },
    platform_level_1_ids: {
      type: 'selector',
      multiple: true,
      options: [],
      selected: true,
      value: [],
      dependencies: [
        'target',
        'desired_value',
        'industry_id',
        'sub_industry_id',
      ],
      apiDependencies: ['industry_id', 'sub_industry_id'],
      apiMethod: 'fetchPlatformLevels1',
    },
    platform_level_2_ids: {
      type: 'selector',
      multiple: true,
      options: [],
      value: [],
      dependencies: [
        'target',
        'desired_value',
        'industry_id',
        'sub_industry_id',
        'platform_level_1_ids',
      ],
      apiDependencies: [
        'industry_id',
        'sub_industry_id',
        'platform_level_1_ids',
      ],
      apiMethod: 'fetchPlatformLevels2',
    },
    strategy_level_1_id: {
      type: 'selector',
      options: [],
      value: '',
      dependencies: [
        'target',
        'desired_value',
        'industry_id',
        'sub_industry_id',
        'platform_level_1_ids',
        'platform_level_2_ids',
      ],
      apiDependencies: [
        'industry_id',
        'sub_industry_id',
        'platform_level_1_ids',
        'platform_level_2_ids',
      ],
      apiMethod: 'fetchStrategyLevels1',
    },
  },
  target_results: {
    type: 'target_results',
    data: {},
    dependencies: [
      'target',
      'desired_value',
      'industry_id',
      'sub_industry_id',
      'platform_level_1_ids',
      'platform_level_2_ids',
      'strategy_level_1_id',
    ],
    apiDependencies: [
      'target',
      'desired_value',
      'industry_id',
      'sub_industry_id',
      'platform_level_1_ids',
      'platform_level_2_ids',
      'strategy_level_1_id',
    ],
    apiMethod: 'fetchTargetValueDistribution',
    tableConfig: {
      columns: {
        platform_level_1: {},
        platform_level_2: {},
        strategy_level_1: {},
        strategy_level_2: {},
        strategy_level_3: {},
        banner_type: {},
        budget: {
          accessorKey: 'budget',
          postfix: '₽',
        },
        shows: {
          accessorKey: 'shows',
        },
        clicks: {
          accessorKey: 'clicks',
        },
        cpm: {
          accessorKey: 'cpm',
          postfix: '₽',
          tooltip: true,
        },
        cpc: {
          accessorKey: 'cpc',
          postfix: '₽',
          tooltip: true,
        },
        ctr: {
          accessorKey: 'ctr',
          postfix: '%',
          tooltip: true,
        },
      },
      sorting: ['budget'],
    },
  },
}
